import { NoopScrollStrategy } from "@angular/cdk/overlay";
import {Component, Inject, OnInit} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { toJSDate } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar";
import { HomeOrdersCopyDialogComponent } from "src/app/home/home-orders/home-orders-copy-dialog/home-orders-copy-dialog.component";
import { LensConfigMode, LensSectionMode } from "src/app/model/configuration/configuration";
import { i18nService } from "src/app/service-utils/i18n.service";
import { LanguagePickerService } from "src/app/utils/language-picker/language-picker.service";
import { NewOrderStoreService } from "../new-order-store-service.service";

@Component({
    selector: 'app-new-order-select-dialog',
    templateUrl: './new-order-select-dialog.component.html',
    styleUrls: ['./new-order-select-dialog.component.scss']
})
export class NewOrderSelectDialogComponent implements OnInit{
    form: FormGroup;
    LensSectionMode = LensSectionMode;
    lensSectionModeSelect: LensSectionMode = LensSectionMode.FINAL_LENS;
    copy: boolean;

    constructor(
      public dialogRef: MatDialogRef<NewOrderSelectDialogComponent>,
      public dialogCopy: MatDialog,
      public i18nService: i18nService,
      private formBuilder: FormBuilder,
      private languagePickerService: LanguagePickerService,
      private newOrderStoreService: NewOrderStoreService,
      private router: Router,
      @Inject(MAT_DIALOG_DATA) public data: any) {
      this.copy = this.data.copy;
    }

    ngOnInit(): void {
    }

    public isEnglish(): boolean {
        return this.languagePickerService.isEnglish();
    }

    public goToNewOrderPage() {
      if(this.lensSectionModeSelect !== LensSectionMode.FINAL_LENS_COPY && this.lensSectionModeSelect !== LensSectionMode.TRIAL_LENS_COPY) {
        this.newOrderStoreService.setLensConfigMode(LensConfigMode.DUAL);
        this.newOrderStoreService.setLensSectionMode(this.lensSectionModeSelect);
        this.newOrderStoreService.setIsLeftSideEnable(true);
        this.newOrderStoreService.setIsRightSideEnable(true);
        this.dialogRef.close();
        this.router.navigate(['/new-order']);
      } else {
        this.newOrderStoreService.setLensSectionMode(this.lensSectionModeSelect);
        this.dialogRef.close();

        this.dialogCopy.open( HomeOrdersCopyDialogComponent, {
          width: '1160px',
          maxHeight: '90vh',
          scrollStrategy: new NoopScrollStrategy()
        });
      }
    }
}
